import {
    streamer,viewer,shop,promotion,obsGateway
} from './request'

// 获取验证码
export const getCode = (mobile) => {
    return streamer.request({
        url:`/api/send-mobile-sms?mobile=${mobile}`,
        method:'post',
        // params:{
        //     mobile
        // }
    })
}

// 验证码登录
export const codeLogin = ({mobile,mobile_verify_code}) => {
    return streamer.request({
        url:'/api/login-mobile',
        method:'post',
        data:{
            mobile,
            mobile_verify_code
        }
    })
}

// 商户登录
export const userLogin = ({username,password}) => {
    return streamer.request({
        url:'/api/login',
        method:'post',
        data:{
            username,
            password
        }
    })
}

// 获取用户信息
export const getUserInfo = () => {
    return streamer.request({
        url:'/api/user/get-user-info',
        method:'get',
    })
}


// 创建推流(直播)
export const createStream = (
  {
    appid,
    live_title='testlive',
    image = 'https://oss.lvtuyanxuan.com/testopen/9lskoRaDBDZilaCg4DQi8ii1zazOsXedsg8ZJDb0.jpg' ,
    time_on = '2025-9-17 20:27:00' ,
    time_out = '2025-10-30 20:27:00'
  }) => {
    return streamer.request({
        url:'/api/stream/create',
        method:'post',
        data:{
            appid,
            live_title,
            image,
            time_on,
            time_out
        }
    })
}

// 修改直播状态
/**
 * @param {stream_name} String  推流名称
 * @param {stream_status} String  0,1,2 0:未开始 1:直播中  2:已结束
 */
export const changeLiveStatus = ({stream_name, stream_status,appid}) => {
    return streamer.request({
        url:'/api/stream/change-status',
        method:'post',
        data:{
            stream_name,
            stream_status,
            appid
        }
    })
}

// 直播数据
/**
 * @param {stream_name} String  推流名称
 */
export const getLiveData = (stream_name, start_time, end_time) => {
    return streamer.request({
        url:`/api/statics/list?stream_name=${stream_name}&start_time=${start_time}&end_time=${end_time}`,
        method:'get',
        // param: {
        //     stream_name,
        //     start_time,
        //     end_time
        // }
    })
}

// 直播间列表
export const liveroomsList = (appid, prepage = 15,page = 1 , time_on) => {
    return streamer.request({
        url:'/api/stream/list',
        // url:`/api/stream/list?time_on=${time_on}&time_out=${time_out}`,
        method:'get',
        params:{
            appid,
            per_page: prepage,
            page,
            ...(time_on ? { time_on } : {})
        }
    })
}

// 为直播间登记 OBS 将要接管的固定主播身份。
// channel/uid 的最终映射由 RTC 服务端保存，前端不把 uid 传给 OBS 接口。
export const registerObsPublisherIdentity = (channel, sessionId) => {
  return obsGateway.request({
    url: '/api/v1/rtc/token',
    method: 'get',
    params: {
      channel,
      role: 'publisher',
      uidMode: 'uid',
      sessionId,
    },
  })
}

// 完整 streamKey 只会在本次创建或同一幂等请求重放时返回。
export const createObsCredentials = (roomId, idempotencyKey) => {
  return obsGateway.request({
    url: `/api/v1/admin/live-rooms/${encodeURIComponent(roomId)}/obs-credentials`,
    method: 'post',
    headers: {
      'Idempotency-Key': idempotencyKey,
    },
    data: {
      confirmSdkStopped: true,
    },
  })
}

// 关闭直播
export const closeLiveroom = (StreamId) => {
    return streamer.request({
        url:`/api/stream/delete/${StreamId}`,
        method:'get'
    })
}

// 直播间弹幕
export const getDanmu = (params) => {
    return streamer.request({
        url:'/api/stream/danmu',
        method:'get',
        params
    })
}

// 直播间禁言
export const Forbidden = ({user_id,stream_name}) => {
    return streamer.request({
        url:'/api/stream/add-user-black-room',
        method:'post',
        data:{
            user_id,
            stream_name
        }
    })
}
export const getProductList = (streamID, page = 1) => {
    return streamer.request({
        url:'/api/product/list',
        params: { stream_id: streamID, page, per_page: 200 },
        method:'get',
    })
}
export const reorderProducts = (data) => streamer.request({
    url: '/api/product/reorder', method: 'post', data
})
export const SaveProduct = (data) => {
    return streamer.request({
        url:'/api/product/save',
        method:'post',
        data
    })
}
export const deleteProduct = (productID, options = {}) => {
    return streamer.request({
        url:'/api/product/delete/'+ productID,
        method:'post',
        suppressErrorNotification: !!options.suppressErrorNotification,
    })
}
export const miaopin_create = (data) => {
    return streamer.request({
        url:'/api/product/create-sku',
        method:'post',
        data
    })
}
export const miaopin_detail = (productID) => {
    return streamer.request({
        url:'/api/product/detail/' + productID,
        method:'get'
    })
}
export const miaopin_swicth_sale_status = (productID) => {
    return streamer.request({
        url:'/api/product/set_on_sale/' + productID,
        method:'post'
    })
}
// 后台
/**
 *  商户注册
 * @param {*} data 
 * @returns 
 */
export function register(data) {
  return shop.request({
    url: '/commercial/register',
    method: 'post',
    data
  })
}
/**
 *  获取商户APPID
 * @returns 
 */
export function getAppid() {
  return shop.request({
    url: '/commercial/get-commercial-applist',
    method: 'get',
  })
}

/**
 *  发送短信
 * @param {*} data 
 * @returns 
 */
export function sendCode({mobile}) {
  return shop.request({
    url: '/commercial/send-mobile-sms',
    method: 'post',
    data: {
      mobile
    }
  })
}

/**
 * @description: 获取商品分类
 */
export function GetGoodsClassify() {
  return shop.request({
    url: '/commercial/product-classify/list',
    method: 'get'
  })
}
/**
 * @description: 获取商品列表
 * @param {number} currentPage --当前页
 * @param {number} per_page -- 每页条数
 * @param {string} where -- 搜索条件
 * @return {*}
 */
export function GetGoodsInfo(page, per_page, where) {
  return shop.request({
    url: '/commercial/product/list',
    method: 'get',
    params: {
      page,
      per_page,
      ...where
    }
  })
}

/**
 * @description: 获取商品详情
 * @param {Numer} name_no -- 商品编号
 * @return {*}
 */
export function GetGoodsDetail(name_no) {
  return shop.request({
    url: '/commercial/product/detail/' + name_no,
    method: 'get'
  })
}

export function listCustomerAccounts(params = {}) {
  return shop.request({
    url: '/commercial/set-site/customer-account-plat/list',
    method: 'get',
    params
  })
}

export function addCustomerAccount(data) {
  return shop.request({
    url: '/commercial/set-site/customer-account-plat/add',
    method: 'post',
    data
  })
}

/**
 * @description: 修改客服账号
{
    "platform": "non",
    "account": "laboriosam",
    "status": 8,
    "config": "qui",
    "remark": "non",
    "nickname": "delectus"  
}
 */
export function updateCustomerAccount(data) {
  return shop.request({
    url: '/commercial/set-site/customer-account-plat/update',
    method: 'post',
    data
  })
}

export function deleteCustomerAccount(id) {
  return shop.request({
    url: '/commercial/set-site/customer-account-plat/del/' + id,
    method: 'delete',
    data: { id }
  })
}

export function listCommercialDomains(params = {}) {
  return shop.request({
    url: '/commercial/domain-bind/list',
    method: 'get',
    params,
  })
}

export function addCommercialDomain(data) {
  return shop.request({
    url: '/commercial/domain-bind/add',
    method: 'post',
    data,
  })
}

export function getCommercialDomainDetail(id) {
  return shop.request({
    url: '/commercial/domain-bind/detail/' + id,
    method: 'get',
  })
}

export function verifyCommercialDomain(id) {
  return shop.request({
    url: '/commercial/domain-bind/verify/' + id,
    method: 'post',
  })
}

export function deleteCommercialDomain(id) {
  return shop.request({
    url: '/commercial/domain-bind/delete/' + id,
    method: 'post',
  })
}



// 文件上传
export function listPromotionCampaigns(params = {}) {
  return promotion.request({
    url: '/api/v1/promotions/campaigns',
    method: 'get',
    params,
  })
}

export function getPromotionCampaign(id, commercialId) {
  return promotion.request({
    url: '/api/v1/promotions/campaigns/' + id,
    method: 'get',
    params: { commercial_id: commercialId },
  })
}

export function createPromotionCampaign(data) {
  return promotion.request({
    url: '/api/v1/promotions/campaigns',
    method: 'post',
    data,
  })
}

export function updatePromotionCampaign(id, data) {
  return promotion.request({
    url: '/api/v1/promotions/campaigns/' + id,
    method: 'patch',
    data,
  })
}

export function savePromotionCampaign(data) {
  const payload = { ...(data || {}) }
  const id = payload.id
  delete payload.id
  return id ? updatePromotionCampaign(id, payload) : createPromotionCampaign(payload)
}

export function setPromotionCampaignStatus({ id, commercial_id, status }) {
  return promotion.request({
    url: '/api/v1/promotions/campaigns/' + id + '/status',
    method: 'patch',
    data: {
      commercial_id,
      status,
    },
  })
}

export function deletePromotionCampaign({ id, commercial_id }) {
  return promotion.request({
    url: '/api/v1/promotions/campaigns/' + id,
    method: 'delete',
    params: { commercial_id },
  })
}

export function createPromotionPaymentOrder(campaignId, commercial_id) {
  return promotion.request({
    url: '/api/v1/promotions/campaigns/' + campaignId + '/payment-orders',
    method: 'post',
    data: {
      commercial_id,
    },
  })
}

export function listCampaignPromotionPaymentOrders(campaignId, params = {}) {
  return promotion.request({
    url: '/api/v1/promotions/campaigns/' + campaignId + '/payment-orders',
    method: 'get',
    params,
  })
}

export function listPromotionPaymentOrders(params = {}) {
  return promotion.request({
    url: '/api/v1/promotions/payment-orders',
    method: 'get',
    params,
  })
}

export function getPromotionPaymentOrder(orderId) {
  return promotion.request({
    url: '/api/v1/promotions/payment-orders/' + orderId,
    method: 'get',
  })
}

export function startPromotionPayment(orderId, payload) {
  const data = typeof payload === 'string'
    ? { channel: payload }
    : { ...(payload || {}) }
  return promotion.request({
    url: '/api/v1/promotions/payment-orders/' + orderId + '/pay',
    method: 'post',
    data,
  })
}

const PROMOTION_HOSTED_GATEWAY = {
  baseUrl: process.env.VUE_APP_PROMOTION_PAYMENT_GATEWAY_URL || 'https://api.sufeipay.com/',
  appId: process.env.VUE_APP_PROMOTION_PAYMENT_GATEWAY_APP_ID || 'ak_48b43e3591024257',
  apiSecret: process.env.VUE_APP_PROMOTION_PAYMENT_GATEWAY_API_SECRET || 'sk_2452716a83dbcdee1bba3dc2f91c5b9e3f9935146d1c287b',
}

const PROMOTION_GATEWAY_ERROR_HINTS = {
  41101: '签名不匹配：请核对 Secret 是否为轮换后的最新值，且 App ID 与 Secret 是否同一把 key。',
  41102: '时间戳超窗：请校准本机时间，网关允许的偏差为 ±300 秒。',
  41103: 'Nonce 重放：请重新发起支付请求。',
  41105: 'HMAC 请求头缺失：需要 X-App-Id、X-Timestamp、X-Nonce、Authorization。',
}

function hexFromBuffer(buffer) {
  return Array.from(new Uint8Array(buffer))
    .map(byte => byte.toString(16).padStart(2, '0'))
    .join('')
}

async function sha256Hex(value) {
  const data = new TextEncoder().encode(value || '')
  return hexFromBuffer(await window.crypto.subtle.digest('SHA-256', data))
}

async function hmacSha256Hex(secret, value) {
  const key = await window.crypto.subtle.importKey(
    'raw',
    new TextEncoder().encode(secret),
    { name: 'HMAC', hash: 'SHA-256' },
    false,
    ['sign']
  )
  return hexFromBuffer(await window.crypto.subtle.sign('HMAC', key, new TextEncoder().encode(value)))
}

function randomNonce(bytes = 8) {
  const data = new Uint8Array(bytes)
  window.crypto.getRandomValues(data)
  return hexFromBuffer(data)
}

async function buildHostedGatewayHeaders(method, path, bodyText) {
  const appId = PROMOTION_HOSTED_GATEWAY.appId
  const secret = PROMOTION_HOSTED_GATEWAY.apiSecret
  const timestamp = Math.floor(Date.now() / 1000).toString()
  const nonce = randomNonce()
  const canonical = [
    appId,
    timestamp,
    nonce,
    method.toUpperCase(),
    path,
    await sha256Hex(bodyText || ''),
  ].join('\n')
  const signature = await hmacSha256Hex(secret, canonical)
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-App-Id': appId,
    'X-Timestamp': timestamp,
    'X-Nonce': nonce,
    Authorization: 'hmac ' + signature,
  }
}

export async function createPromotionHostedCashierIntent(order) {
  if (!window.crypto?.subtle) {
    throw new Error('当前浏览器环境不支持 Web Crypto，请使用 localhost 或 HTTPS 打开页面')
  }

  const path = '/v1/intents'
  const amount = String(order?.original_amount || order?.settlement_amount || 0)
  const currency = String(order?.original_currency || order?.settlement_currency || 'USD').toUpperCase()
  const expiresInSeconds = order?.expire_at
    ? Math.max(60, Math.floor((Number(order.expire_at) - Date.now()) / 1000))
    : 1800
  const body = {
    merchant_order_id: order?.order_no || `promotion-${order?.id || Date.now()}`,
    amount,
    currency,
    coin: '',
    expires_in_seconds: expiresInSeconds,
  }
  const bodyText = JSON.stringify(body)
  const response = await fetch(PROMOTION_HOSTED_GATEWAY.baseUrl.replace(/\/$/, '') + path, {
    method: 'POST',
    headers: await buildHostedGatewayHeaders('POST', path, bodyText),
    body: bodyText,
  })
  const payload = await response.json().catch(() => ({}))
  if (!response.ok || (payload && payload.code !== undefined && Number(payload.code) !== 0)) {
    const hint = PROMOTION_GATEWAY_ERROR_HINTS[Number(payload?.code)]
    const message = [payload?.msg || payload?.message || `Payment gateway create failed: HTTP ${response.status}`, hint]
      .filter(Boolean)
      .join('；')
    const error = new Error(message)
    error.payload = payload
    throw error
  }
  const data = payload?.data && typeof payload.data === 'object' ? payload.data : payload
  const hostedUrl = data.hosted_cashier_url || data.pay_url || data.checkout_url || data.cashier_url
  if (!hostedUrl) {
    throw new Error('Payment gateway response missing hosted_cashier_url')
  }
  return {
    code: 0,
    data: {
      id: data.id || data.intent_id || '',
      gateway_order_no: data.id || data.intent_id || '',
      pay_url: hostedUrl,
      status: 'pending',
      pay_action: 'redirect',
      checkout_mode: 'hosted_cashier',
      gateway_response: data,
    },
  }
}

export function cancelPromotionPayment(orderId) {
  return promotion.request({
    url: '/api/v1/promotions/payment-orders/' + orderId + '/cancel',
    method: 'post',
  })
}

export function queryPromotionPaymentStatus(orderId) {
  return promotion.request({
    url: '/api/v1/promotions/payment-orders/' + orderId + '/status',
    method: 'get',
  })
}

export function listNotifications(params = {}) {
  return promotion.request({
    url: '/api/v1/notifications',
    method: 'get',
    params,
  })
}

export function markNotificationRead(id, commercialId) {
  return promotion.request({
    url: '/api/v1/notifications/' + id + '/read',
    method: 'post',
    data: {
      commercial_id: commercialId,
    },
  })
}

export function createNotificationStream(commercialId) {
  const baseURL = String(promotion.defaults.baseURL || '').replace(/\/$/, '')
  const query = new URLSearchParams({ commercial_id: commercialId })
  return new EventSource(`${baseURL}/api/v1/notifications/stream?${query.toString()}`)
}

export function uploadFile(data) {
  return streamer.request({
    url: '/api/filemanager',
    method: 'post',
    data
  })
}

export function uploadPromotionFile(data) {
  return promotion.request({
    url: '/api/v1/uploads/files',
    method: 'post',
    data
  })
}

export function reportLiveBehaviorEvent(data) {
  return promotion.request({
    url: '/api/v1/visits/events/behavior',
    method: 'post',
    data,
  })
}

export function getLiveIntentAnalytics(params = {}) {
  return promotion.request({
    url: '/api/v1/analytics/live-intent',
    method: 'get',
    params,
  })
}

export function getLiveIntentMonitoring(params = {}) {
  return promotion.request({
    url: '/api/v1/analytics/live-intent/monitoring',
    method: 'get',
    params,
  })
}

export const danmuApi = {
    warmupDanmuList(category_id,appid = 1) {
        return streamer.request({
            url:'/api/test-danmu/list',
            method:'get',
            params:{
                appid,
                category_id
            }
        })
    },
    // appid:1 
    // category_id:1  分类ID
    // room_id:1 房间ID
    // timer:60  发送间隔
    // retry_count:3  发送次数
    // task_list:true  true随机  false顺序
    warmupDanmuTaskCreate(data) {
        return streamer.request({
            url:'/api/test-danmu/create-task',
            method:'post',
            data
        })
    },
    warmupDanmuTaskList(room_id) {
        return streamer.request({
            url:'/api/test-danmu/task-list',
            method:'post',
            data:{
                room_id
            }
        })
    },
    warmupDanmuTaskCancel(task_id) {
        return streamer.request({
            url:'/api/test-danmu/task-cancel/' + task_id,
            method:'post',
        })
    },
    // "message": "['测试弹幕1','测试弹幕2']",
    // "category_id": 1,
    // "category_title": "'测试分类'",
    // "appid": 1
    warmupDanmuAdd(data) {
        return streamer.request({
            url:'/api/test-danmu/add-danmu',
            method:'post',
            data
        })
    },
    warmupDanmuDel(id) {
        return streamer.request({
            url:'/api/test-danmu/del-danmu/'+ id,
            method:'post',
        })
    },
}

// 创建红包 POST /api/red-packet/create
export const createRedPacket = (data) => {
  return streamer.request({
    url: '/api/red-packet/create',
    method: 'post',
    data
  })
}

// 发放红包 POST /api/red-packet/give-out
export const giveOutRedPacket = (red_packet_id) => {
  return streamer.request({
    url: '/api/red-packet/give-out',
    method: 'post',
    data: { red_packet_id }
  })
}

// 撤回红包 POST /api/red-packet/revoke
export const revokeRedPacket = (red_packet_id) => {
  return streamer.request({
    url: '/api/red-packet/revoke',
    method: 'post',
    data: { red_packet_id }
  })
}

// 红包列表 GET /api/red-packet/list
// 你 txt 里只写了 list 接口，没有给参数示例；这里做宽松支持：room_id / red_packet_id 可选
export const listRedPackets = (params) => {
  return streamer.request({
    url: '/api/red-packet/list',
    method: 'get',
    params
  })
}

// 红包详情 GET /api/red-packet/detail?red_packet_id=xx
export const redPacketDetail = (red_packet_id) => {
  return streamer.request({
    url: '/api/red-packet/detail',
    method: 'get',
    params: { red_packet_id }
  })
}
